<template>
    <button class="close"><span>&times;</span></button>
</template>
